/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { CoreNetworking } from '@airasia-rn/ui';
import {
  FlightRecommendationsRequest,
  OuterFlightRecommendationsResponse,
} from '../types/flightRecommendations.types';
import EnvironmentURLs, { parseEnv } from '../util/EnvironmentURLs';

declare const __DEV__: boolean;

export type Environment = 'stg' | 'prd';

export class FlightRecommendationsApiService {
  constructor(private environment: Environment) {}
  private getFlightRecommendationsUrl(): string {
    return EnvironmentURLs.FLIGHT_RECOMMENDATIONS[parseEnv(this.environment)];
  }
  async fetchFlightRecommendations(
    payload: FlightRecommendationsRequest,
    signal?: AbortSignal,
  ): Promise<OuterFlightRecommendationsResponse> {
    try {
      const url = this.getFlightRecommendationsUrl();
      const response = await CoreNetworking.post(url, payload, {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        signal,
      });

      // CoreNetworking behaves like axios
      return response?.data as OuterFlightRecommendationsResponse;
    } catch (err) {
      if (__DEV__) {
        console.log('❌ [FlightRecommendationsApi] Fetch ERROR:', err);
      }
      throw err;
    }
  }
}
